import { Pipe, PipeTransform } from '@angular/core';
//import moment from 'moment-es6';
import { MomentService } from '../moment/moment.service';

@Pipe({ name: 'wlDayDifferenceCount', pure: true, standalone: false })
export class WlDayDifferenceCountPipe implements PipeTransform {
  transform(value: Date): number {
    let momentService: MomentService = new MomentService();
    var today = momentService.getMomentByDate(new Date()).startOf('day');
    var endDate = momentService.getMomentByObject(value).startOf('day');

    return Math.abs(endDate.diff(today, 'days'));
  }
}
